import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import Faq from 'components/Common/Faq'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import Group from 'components/utils/Group'
import config from 'constants/config'

const FaqSectionWrapper = styled.div`
  padding: ${rem(24)} 0;

  ${mediaQueryUp.tablet} {
    padding: ${rem(24)} 0;
  }
`

interface Props {
  headingAlign?: 'center' | 'start'
}

function LuxPlusLandingFaqSection({ headingAlign = 'start' }: Props) {
  const intl = useIntl()

  return (
    <FaqSectionWrapper>
      <LayoutContainer variant="medium">
        <VerticalSpacer gap={24}>
          <Heading variant="heading3" as="h2" align={headingAlign === 'center' ? 'center' : undefined}>
            {intl.formatMessage({
              id: 'x_jFKIihdA42L7m9Fqqg',
              defaultMessage: 'Frequently Asked Questions',
              description: 'Heading for the FAQ section on the LuxPlus landing page',
            })}
          </Heading>
          <Faq slug="luxplus-faqs" />
          <Group direction="horizontal" horizontalAlign="center" gap={12} wrap="wrap">
            <TextButton
              kind="secondary"
              to={config.contentLinks.luxPlusTermsAndConditions.to}
              target="_blank"
              rel="noopener noreferrer"
            >
              {intl.formatMessage({
                id: 'uvfwxygkw2FobrbTcG7M',
                defaultMessage: 'LuxPlus+ Terms and Conditions',
                description: 'Button to navigate to the LuxPlus+ terms and conditions page from the landing FAQ section',
              })}
            </TextButton>
          </Group>
        </VerticalSpacer>
      </LayoutContainer>
    </FaqSectionWrapper>
  )
}

export default LuxPlusLandingFaqSection
